export const CURRENT_MEETING = "prevent_meet_03_26";
export const CURRENT_MEETING_TITLE = "PREVENT Spring 2026 Meeting";
export const CURRENT_MEETING_LINK =
  "https://usc.zoom.us/j/96211606140?pwd=DWpc8OzhR8atFmFA7DQGFECypXWC8p.1";
export const CURRENT_MEETING_DATE =
  "Friday March 6th 2026, 3:45 PM - 5:45 PM Mountain Standard Time";
export const CURRENT_MEETING_LOCATION =
  "PALISI Meeting (In-Person and Virtual)";

// Old meeting date "Wednesday September 10th, 2025 1:30 PM – 3:30 PM Eastern Time (US and Canada)"
